// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.D3RenderingServices.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { d3 } from './Izenda.D3Wrapper';
import { isUndefined, isFunction } from 'lodash/fp';
import D3ChartStyles from './Izenda.D3ChartStyles';

export default class D3RenderingServices {
  /**
   * Constructor
   * @param {SVG} host
   * @param {DOMElement} container
   */
  constructor(host, container) {
    ensure(!isUndefined(host), 'Host must be provided.');

    this.host = host;
    this.baseOptions = {
      container,
      tooltip: this.buildTooltipLayer(container)
    };
  }

  /**
   * Draw chart with specific options
   * @param {Object} options
   */
  draw(options) {
    const {
      chart: { type }
    } = options;
    const extendedOptions = Object.assign({}, this.baseOptions, options);
    const drawFn = D3ChartStyles.get(type);

    const { clientWidth: width, clientHeight: height } = this.baseOptions.container;
    this.host.attr('viewBox', [0, 0, width, height]);

    isFunction(drawFn) && drawFn.call(this, this.host, extendedOptions);
    return Promise.resolve(true);
  }

  /**
   * Build tooltip layer
   * @param {DOMElement} container
   */
  buildTooltipLayer(container) {
    const tooltip = d3.select(container).select('div .d3-tooltip');
    return tooltip.empty()
      ? d3
          .select(container)
          .append('div')
          .classed('d3-tooltip', true)
      : tooltip;
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/charting/d3/Izenda.D3RenderingServices.js